module.exports = __webpack_public_path__ + "images/Trash.405e2d62e4fa7bbbb32852830c78a26e.svg";